import React, { useEffect } from 'react'
import { Grid } from '@material-ui/core'
import { Button, Input, SelectInput } from 'src/components'
import { useFormContext } from 'react-hook-form'
import { useStyles } from './styles'
import { HealthControlForm } from 'src/@types/validations/Animal'
import { LotDto } from 'src/dto/lot.dto'
import { useGetAnimalListByLot } from 'src/hooks/api/animal/useGetAnimalListByLot'
import { formatDateToInputValue } from 'src/utils'

interface LoteHealthControlProps {
  lotList: LotDto[]
  onpenVaccineModal: () => void
}

export const LoteHealthControl: React.FC<LoteHealthControlProps> = ({ lotList, onpenVaccineModal }) => {
  const {
    watch,
    setValue,
    clearErrors,
    setError,
    formState: { errors }
  } = useFormContext<HealthControlForm>()

  const styles = useStyles()

  const selectedLote = watch('idLote')

  const { data: animalListByLoteList } = useGetAnimalListByLot(selectedLote!)

  useEffect(() => {
    if (!selectedLote) return

    if (!animalListByLoteList?.length) {
      setValue('animais', [])
      setError('idLote', {
        message: 'O lote selecionado não possui animais.'
      })
      return
    }

    const activeAnimals = animalListByLoteList.filter((animal) => animal.categoria !== 'VD' && animal.categoria !== 'MT')
    const allIds = activeAnimals.map((animal) => animal.idAnimal) as string[]
    setValue('animais', allIds)
  }, [selectedLote, animalListByLoteList])

  return (
    <>
      <div className={styles.inputWithEditToggle}>
        <SelectInput
          label='Lote origem'
          selectBy='idLote'
          showBy={['descricao']}
          options={lotList}
          value={watch('idLote') || ''}
          // disabled={!!saleData?.idVenda}

          error={errors?.idLote?.['message']}
          placeholder='Selecionar lote de origem'
          onChange={(item: any) => {
            setValue('idLote', item.id)
            clearErrors('idLote')
          }}
        />

        <Grid container spacing={3} style={{ marginTop: 8 }}>
          <Grid item xs={12} sm={6} style={{ padding: '0px 12px' }}>
            <Input
              type='date'
              max='2999-12-31'
              label='Data de aplicação'
              id='dataAplicacao'
              error={errors?.dataAplicacao?.message}
              onChange={(value: string) => {
                const newDate = new Date(value).toISOString()
                setValue('dataAplicacao', newDate)
                clearErrors('dataAplicacao')
              }}
              value={formatDateToInputValue(watch('dataAplicacao') || '')}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ padding: '0px 12px', display: 'flex', alignItems: 'center' }}>
            <div className={styles.buttonContainer}>
              <Button className={styles.buttonWrapper} type='button' onClick={onpenVaccineModal}>
                Adicionar medicamentos
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  )
}
